import { useEffect, useState } from 'react';

import { isEuCountryCode } from '@utils/euCountries';
import { isBrowser } from '@utils';

let cachedCountryCode = null;
let pendingRequest = null;

const fetchCountryCode = async () => {
  if (cachedCountryCode !== null) return cachedCountryCode;
  if (pendingRequest) return pendingRequest;

  pendingRequest = fetch('/api/geolocation')
    .then((response) => (response.ok ? response.json() : {}))
    .then((data) => {
      cachedCountryCode = data?.['x-country'] || null;
      pendingRequest = null;
      return cachedCountryCode;
    })
    .catch((error) => {
      pendingRequest = null;
      throw new Error(error?.message || 'Failed to fetch geolocation');
    });

  return pendingRequest;
};

export const useIsEuVisitor = () => {
  const [isEu, setIsEu] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isBrowser) return;

    const resolveGeolocation = async () => {
      try {
        const countryCode = await fetchCountryCode();
        setIsEu(isEuCountryCode(countryCode));
      } catch (error) {
        console.log('useIsEuVisitor:error', error.message);
        setIsEu(false);
      } finally {
        setIsLoading(false);
      }
    };

    resolveGeolocation();
  }, []);

  return { isEu, isLoading };
};
